import classNames from '../../utils/classNames'
import Icon from '../icon'

const Checkbox = ({
  type = 'circle',
  isChecked,
  onChange,
  className,
}: {
  isChecked: boolean
  onChange: () => void
  className?: string
  type?: 'circle' | 'check'
}) => {
  return (
    <button
      className={classNames(
        'flx-ctr w-5 h-5 min-w-5 rounded-full border-2',
        isChecked ? 'border-txt' : 'border-secondary-txt',
        className,
      )}
      onClick={onChange}>
      {isChecked && type === 'circle' && (
        <span className="w-3.5 h-3.5 min-w-3.5 rounded-full bg-highlight" />
      )}
      {isChecked && type === 'check' && (
        <Icon id="check" width={20} height={20} className="stroke-txt" />
      )}
    </button>
  )
}

export default Checkbox
